document.addEventListener(
  "click",
  event => {
    const trigger = event.target.closest('[data-behavior="tax-conversation-form"]');

    if (!trigger) {
      return;
    }

    const costCenter = document.getElementById("conversation_cost_center").value;
    const costUnit = document.getElementById("conversation_cost_unit").value;
    let errors = [];

    if (!costCenter.length) {
      errors.push('"Kostenstelle"');
    }

    if (!costUnit.length) {
      errors.push('"Kostenträger"');
    }

    let title = "Anfrage senden";
    let commit = "Senden";
    let text = "";

    const consultation = trigger.dataset.consultation;

    if (consultation === "charged") {
      title = "Kostenpflichtige Frage senden";
      commit = "Kostenpflichtig senden";
      text =
        `Diese Frage wird mit ${trigger.dataset.consultationNet} netto ` +
        `(${trigger.dataset.consultationGross} brutto inkl. Umsatzsteuer) berechnet. ` +
        "Mit dem Absenden entsteht eine kostenpflichtige Beratungsleistung, für die automatisch eine Rechnung erstellt wird. ";
    } else if (consultation === "free") {
      text =
        "Diese Frage wird aus Ihrem kostenlosen Testkontingent abgedeckt und ist für Sie kostenfrei. ";
    }

    text +=
      "Um Ihre Anfrage bearbeiten zu können, muss diese vollständig sein. Sind Sie sicher, dass Ihre Angaben vollständig sind und Sie die Anfrage senden möchten?";

    if (errors.length > 0) {
      text += ` Zu beachten: Sie haben ${errors.join(" und ")} nicht ausgefüllt.`;
    }

    event.preventDefault();

    dataConfirmModal.confirm({
      title: title,
      text: text,
      commit: commit,
      cancel: "Abbrechen",
      zIindex: 10099,
      onConfirm: () => {
        trigger.closest("form").submit();
      }
    });
  },
  false
);
